import { Link } from 'react-router-dom';

const steps = [
  {
    num: '01',
    icon: 'ri-lightbulb-line',
    title: '收集线索',
    desc: '记录你的亲历见闻：聊天截图、照片、视频、票据等，均可作为线索佐证材料。',
  },
  {
    num: '02',
    icon: 'ri-send-plane-line',
    title: '提交投稿',
    desc: '通过本站17爆料投稿表单在线提交，或通过17爆料私信渠道联系我们。支持匿名投稿。',
  },
  {
    num: '03',
    icon: 'ri-search-eye-line',
    title: '编辑核实',
    desc: '编辑部对线索进行多方核查，联系当事方、查阅公开信息，确保内容准确客观。',
  },
  {
    num: '04',
    icon: 'ri-megaphone-line',
    title: '核实发布',
    desc: '通过核实的报道公开发布，并持续跟踪后续进展，直至问题得到回应或解决。',
  },
];

export default function HowToSubmit() {
  return (
    <section className="bg-background-100 py-14 md:py-20" aria-labelledby="how-heading">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 id="how-heading" className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            17爆料投稿方式
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            从线索收集到核实发布，四个步骤，让你的声音被更多人听见
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
          {steps.map((step) => (
            <div key={step.num} className="relative bg-background-50 rounded-lg p-6 border border-background-200">
              <span className="absolute top-4 right-4 text-4xl font-black text-background-200 font-heading select-none">
                {step.num}
              </span>
              <div className="w-10 h-10 flex items-center justify-center rounded bg-primary-100 text-primary-600 mb-4">
                <i className={`${step.icon} text-xl`} />
              </div>
              <h3 className="font-heading font-bold text-foreground-900 mb-2">{step.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>

        {/* Submit channels */}
        <div className="bg-foreground-950 rounded-lg p-6 md:p-8 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="font-heading text-lg font-bold text-background-50 mb-2">多种17爆料入口，总有一种适合你</h3>
            <div className="flex flex-wrap gap-4 mt-3">
              {[
                { icon: 'ri-edit-line', label: '在线投稿表单', desc: '最推荐，支持上传附件' },
                { icon: 'ri-message-3-line', label: '私信渠道', desc: '匿名沟通，保护隐私' },
                { icon: 'ri-mail-line', label: '邮件投稿', desc: 'tips@17baoliao.com' },
              ].map((ch) => (
                <div key={ch.label} className="flex items-start gap-2">
                  <div className="w-7 h-7 flex items-center justify-center rounded bg-primary-500/20 text-primary-400 flex-shrink-0 mt-0.5">
                    <i className={`${ch.icon} text-sm`} />
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-background-50">{ch.label}</p>
                    <p className="text-xs text-background-400">{ch.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <Link
            to="/submit"
            className="flex-shrink-0 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-md transition-colors whitespace-nowrap text-sm"
          >
            前往投稿页面 →
          </Link>
        </div>
      </div>
    </section>
  );
}